import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import moment from "moment";
import constants from "../../core/constants";
class HolidaysPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Holiday",
      state: "holiday",
      name: "holiday",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "Date", name: "date" },
      { title: "City", name: "city" },
    ];

    this.filters = [
      { name: "city", title: "City", icon: "location_city", resource: "City" },
    ];
  }

  justify(data) {
    const format = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.date = moment(item.date).format(constants.dateTimeFormat);

      return item;
    };

    return map(format)(data);
  }
}

export default HolidaysPageTransform;



// WEBPACK FOOTER //
// ./src/pages/holidays/holidays.transforms.js